import React from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { Logo } from "./Logo";
import { CONTACT_EMAIL, NAV_LINKS, FEATURE_LINKS } from "../lib/content";

const legalLinks = [
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Terms of Service", to: "/terms-of-service" },
  { label: "Cookie Policy", to: "/cookie-policy" },
  { label: "Data Protection (GDPR)", to: "/gdpr" },
  { label: "Account & Data Deletion", to: "/account-deletion" },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative mt-32 border-t border-white/10 bg-[#070707]">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" />
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 md:grid-cols-12 md:px-10">
        <div className="md:col-span-4">
          <Logo />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-zinc-500">
            Building the future of fitness — where every workout, meal, step and health insight works together.
          </p>
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            data-testid="footer-email"
            className="mt-6 inline-flex items-center gap-2 text-sm text-gold transition-colors hover:text-gold-light"
          >
            <Mail className="h-4 w-4" /> {CONTACT_EMAIL}
          </a>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">Company</h4>
          <ul className="mt-5 space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-sm text-zinc-400 transition-colors hover:text-white">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">Platform</h4>
          <ul className="mt-5 space-y-3">
            {FEATURE_LINKS.map((l) => (
              <li key={l.to + l.label}>
                <Link to={l.to} className="text-sm text-zinc-400 transition-colors hover:text-white">
                  {l.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/kingdom-score" className="text-sm text-zinc-400 transition-colors hover:text-white">
                Kingdom Score
              </Link>
            </li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">Legal</h4>
          <ul className="mt-5 space-y-3">
            {legalLinks.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-sm text-zinc-400 transition-colors hover:text-white">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-6 py-6 text-xs text-zinc-600 md:flex-row md:px-10">
          <p>© {new Date().getFullYear()} Jollof Fit Kingdom. All rights reserved.</p>
          <p>Build Today. Rule Tomorrow.</p>
        </div>
      </div>
    </footer>
  );
}
